(function () {
    'use strict';
    var m = angular.module('dao');
    m.service('policyRulesDao', ["http", "$q", function (http, $q) {
        return {
            list: function () {
                return http.get('/api/v1/policy_rule');
            },
            count: function () {
                return http.get('/api/v1/policy_rule').pagination(0, 1);
            },
            create: function (rule) {
                return http.post('/api/v1/policy_rule').body(rule).run();
            },
            retrieve: function (ruleId) {
                return http.get('/api/v1/policy_rule/' + ruleId);
            },
            update: function (ruleId, rule) {
                return http.put('/api/v1/policy_rule/' + ruleId).body(rule).run();
            },
            delete: function (ruleId) {
                return http.delete('/api/v1/policy_rule/' + ruleId).run();
            },
            reorder: function (ruleId1, ruleId2) {
                return http.post('/api/v1/policy_rule/reorder').body({
                    rule_id_1: ruleId1,
                    rule_id_2: ruleId2
                }).run();
            },
            ruleActions: function (saas) {
                return http.get('/api/v1/security_action_types/' + saas);
            },
            updateActionType: function (actionId, action) {
                return http.post('/api/v1/security_action_type/' + actionId).body(action).run();
            },
            retrieveAlertTemplate: function (ruleId, tempId) {
                return http.get('/api/v1/policy_rule_alert_template/' + ruleId).params({ template_id: tempId });
            },
            updateActionTypePerRule: function (ruleId, data) {
                return http.put('/api/v1/policy_rule_alert_template/' + ruleId).body(data).run();
            },
            dlpRules: function () {
                return http.get('/api/v1/normalized_dlp_rule').onRequestFail(function (error) {
                    return $q.when({ data: { normalized_rules: [] } });
                });
            },
            toolSpecificRules: function () {
                return http.get('/api/v1/dlp_matches_rules');
            },
            toolSpecificRule: function (module) {
                return http.get('/api/v1/dlp_matches_rules/' + module);
            },
            anomalyTypes: function () {
                return http.get('/api/v1/anomaly_types').onRequestFail(function (error) {
                    return $q.when({ data: { normalized_rules: [] } });
                });
            },
            staticPhishingTypes: function () {
                return http.get('/api/v1/ap_avanan/static_results').onRequestFail(function (error) {
                    return $q.when({ data: {} });
                });
            }
        };
    }]);
}());